import { COURSE_PLAY_PATH } from "../audio/play-button.js";
import { courseUiText } from "../copy.js";

<const/uiLang=$global.uiLang || input.copy?.uiLang || 'en'/>
<if=input.src>
  <button
    type="button"
    class=["ll-course-play", input.big && "ll-course-play--big"]
    data-ll-audio=input.src
    aria-label=(input.label || courseUiText("Play", uiLang))
  >
    <svg viewBox="0 0 24 24" aria-hidden="true"><path d=COURSE_PLAY_PATH fill="currentColor"/></svg>
  </button>
</if>
